<div class="ring">
  <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">
    <circle cx="50" cy="50" r="40" stroke-width="7" fill="none"></circle>
    <circle
      cx="50"
      cy="50"
      r="40"
      stroke-width="7"
      fill="none"
      [style.stroke-dashoffset]="250 - (250 * value) / 100"
      [style.stroke]="color"
    ></circle>
  </svg>
  @if (label) {
    <span>{{ value != null ? (value | number: '1.0-0') : '-' }}</span>
  }
</div>
